import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { App } from '../../shared/containers/app/app';
import { Home } from '../../shared/containers/HomeContainer';
import { ApplicationContext } from '../../shared/reactContext/applicationContext';
import { IApplicationContext } from '../../shared/types/application';
import { IReduxStore } from '../../shared/types/redux';

interface IDependencies {
  store: IReduxStore;
  context: IApplicationContext;
}

export function renderApplication(dependencies: IDependencies) {
  const { store, context } = dependencies;

  const projectName = 'mainpage'; // TODO get from config
  const rootElement = document.getElementById(projectName as string);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  ReactDOM.hydrate(
    <ApplicationContext.Provider value={context}>
      <Provider store={store} key="provider">
        <App store={store}>
          <Home section={window.__mainpage_section__} />
        </App>
      </Provider>
    </ApplicationContext.Provider>,
    rootElement,
  );
}
